import * as React from 'react'

export const SheetContext = React.createContext<{ contentElement: HTMLDivElement | null, setContentElement: React.Dispatch<React.SetStateAction<HTMLDivElement | null>> }>({ contentElement: null, setContentElement: () => {} })

export function useSetContentElement(contentElementRef: React.RefObject<HTMLDivElement | null> | null) {
  const { setContentElement } = React.use(SheetContext)

  React.useEffect(() => {
    setContentElement(contentElementRef?.current || null)
  }, [contentElementRef])
}
